"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerMovementSystem = void 0;
const gotti_1 = require("gotti");
const types_1 = require("../../../Shared/types");
const Constants_1 = require("../../../Shared/Constants");
const Utils_1 = require("../../../Shared/Utils");
const AheadOfPlayerOffsets = {
    north: { x: 0, y: 0 },
    south: { x: 0, y: 25 },
    west: { x: -10, y: 17 },
    east: { x: 10, y: 17 },
};
class PlayerMovementSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.PLAYER_MOVEMENT);
        this.remotePlayers = [];
        this.npcPlayers = [];
        this.possibleLineCollisions = [];
        const addPossibleCollisionToArray = (colB) => {
            if (colB.isRect) {
                Utils_1.getSegmentsFromRect(colB.shapeData).forEach(a => {
                    this.possibleLineCollisions.push({ p1: { x: a[0].x, y: a[0].y }, p2: { x: a[1].x, y: a[1].y } });
                });
            }
            else if (colB.isLine) {
                const a = colB.shapeData;
                this.possibleLineCollisions.push({ p1: { x: a[0].x, y: a[0].y }, p2: { x: a[1].x, y: a[1].y } });
            }
        };
        this.playerBlockingPlugin = {
            type: 'collision',
            name: 'wall_resolution',
            tagAs: [Constants_1.COLLIDER_TAGS.client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.blocking, Constants_1.COLLIDER_TAGS.water],
            onCollisionStart: (colA, colB) => {
                if (!this.clientCollider)
                    return;
                addPossibleCollisionToArray(colB);
            },
            onCollision: (colA, colB) => {
                if (!this.clientCollider)
                    return;
                addPossibleCollisionToArray(colB);
            },
            onAfterCollisions: () => {
                if (this.clientCollider && this.possibleLineCollisions.length) {
                    const circlePositionBefore = { x: this.clientCollider.shapeData.x, y: this.clientCollider.shapeData.y };
                    const circle = Object.assign(Object.assign({}, this.clientCollider.shapeData), { diameter: this.clientCollider.shapeData.r * 2, radius: this.clientCollider.shapeData.r });
                    this.possibleLineCollisions.forEach((c, i) => {
                        let collisionData = Utils_1.lineCircleData(c.p1.x, c.p1.y, c.p2.x, c.p2.y, circle.x, circle.y, circle.radius);
                        if (collisionData) {
                            const { x, y } = Utils_1.resolveLineCircleCollisionPosition(collisionData, circle);
                            circle.x = x + circle.radius;
                            circle.y = y + circle.radius;
                        }
                    });
                    this.resolvedPlayerPositionDeltas = {
                        x: circle.x - circlePositionBefore.x,
                        y: circle.y - circlePositionBefore.y
                    };
                    const p = this.globals.clientPlayer.setPositionByDeltas(this.resolvedPlayerPositionDeltas.x, this.resolvedPlayerPositionDeltas.y);
                    this.setHeadDataFrom(p.x, p.y);
                    this.possibleLineCollisions.length = 0;
                }
            }
        };
    }
    onClear() {
    }
    onLocalMessage(message) { }
    onServerMessage(message) {
    }
    onEntityAddedComponent(entity, component) {
        if (!entity.hasComponent(Constants_1.SYSTEMS.POSITION))
            throw new Error(`Entities added with a player movement component should have a position component added first always.`);
        if (entity.type === types_1.EntityTypes.ClientPlayer) {
            this.clientPlayer = entity;
            if (!this.clientPlayer.gameObject) {
                entity.once('gameobject-ready', (gameObject) => {
                    this.clientCollider = gameObject.colliders[0];
                });
            }
            else {
                this.clientCollider = this.clientPlayer.gameObject.colliders[0];
            }
            const p = this.clientPlayer.getPosition();
            this.aheadOfPlayerGameObject = this.globals.tileWorld.addGameObject({
                texture: PIXI.Texture.EMPTY,
                position: Object.assign({}, p),
                layer: 1,
                colliders: [{
                        layer: 2,
                        dynamic: true,
                        shapeData: { x: 0, y: 0, w: 20, h: 20 },
                        tags: [Constants_1.COLLIDER_TAGS.in_front_of_client_player]
                    }]
            });
        }
        else if (entity.type === types_1.EntityTypes.RemotePlayer) {
            this.remotePlayers.push(entity);
        }
        else {
            //console.error(entity);
            throw new Error(`Unexpected entity: ${entity.id} had a player movement entity`);
        }
    }
    getAheadOfPlayerPosition() {
        const { x, y, w, h } = this.aheadOfPlayerGameObject.colliders[0].shapeData;
        return { x: (x + w / 2), y: (y + h / 2) };
    }
    onEntityRemovedComponent(entity, component) {
        if (entity.type === types_1.EntityTypes.ClientPlayer) {
            if (this.clientPlayer && entity !== this.clientPlayer) {
                throw new Error(`Unexpected entity marked as client losing component.`);
            }
            this.clientPlayer = null;
        }
        else if (entity.type === types_1.EntityTypes.RemotePlayer) {
            this.remotePlayers = this.remotePlayers.filter(r => r !== entity);
        }
        else {
            //console.error(entity);
            throw new Error(`Unexpected entity: ${entity.id} had a player movement entity`);
        }
    }
    getVelocitiesFromInput(speed, input) {
        const s = { x: 0, y: 0 };
        if (input.moveDown) {
            s.y += speed;
            return s;
        }
        ;
        if (input.moveUp) {
            s.y -= speed;
            return s;
        }
        ;
        if (input.moveLeft) {
            s.x -= speed;
            return s;
        }
        ;
        if (input.moveRight) {
            s.x += speed;
            return s;
        }
        ;
        return s;
    }
    onInit() {
        this.globals.tileWorld.use(this.playerBlockingPlugin);
        this.addApi(this.getAheadOfPlayerPosition);
    }
    setHeadDataFrom(x, y) {
        var _a;
        const pmc = this.getSystemComponent(this.clientPlayer);
        let offsets;
        if (pmc.movingDirection !== null) {
            offsets = AheadOfPlayerOffsets[pmc.movingDirection];
        }
        else {
            const actionComponent = this.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ACTION);
            const aniComponent = this.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION);
            const dir = ((_a = aniComponent.skeleton) === null || _a === void 0 ? void 0 : _a.direction) || this.clientPlayer.getComponent(Constants_1.SYSTEMS.GAME_STATE).data.direction;
            offsets = AheadOfPlayerOffsets[dir];
        }
        this.aheadOfPlayerGameObject.setPosition(x + offsets.x, y + offsets.y);
    }
    update(delta) {
        var _a;
        //!this.$api.isShopOpen()
        if (this.clientPlayer && !this.$api.isInventoryOpen() && !this.$api.isInDialogue() && !this.$api.isSwinging() && !this.$api.isShoveling()) {
            const pmc = this.getSystemComponent(this.clientPlayer);
            if (pmc.disabled) {
                const aniComponent = this.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION);
                const dir = ((_a = aniComponent.skeleton) === null || _a === void 0 ? void 0 : _a.direction) || this.clientPlayer.getComponent(Constants_1.SYSTEMS.GAME_STATE).data.direction;
                const offsets = AheadOfPlayerOffsets[dir];
                const finalPosition = this.clientPlayer.getPosition();
                this.aheadOfPlayerGameObject.setPosition(finalPosition.x + offsets.x, finalPosition.y + offsets.y);
                return;
            }
            ;
            const actionComponent = this.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ACTION);
            if (actionComponent === null || actionComponent === void 0 ? void 0 : actionComponent.action) {
                pmc.setVelocities(0, 0);
                return;
            }
            ;
            let finalSpeed = pmc.speed;
            const { x, y } = this.getVelocitiesFromInput(finalSpeed, this.clientPlayer.playerInput);
            pmc.setVelocities(x, y);
            const deltaX = x * delta;
            const deltaY = y * delta;
            const p = this.clientPlayer.getComponent(Constants_1.SYSTEMS.POSITION);
            let finalPosition = p.getPosition();
            if (x || y) {
                finalPosition = p.setPositionByDeltas(deltaX, deltaY);
            }
            this.setHeadDataFrom(finalPosition.x, finalPosition.y);
        }
    }
    onPeerMessage(peerId, message) {
    }
}
exports.PlayerMovementSystem = PlayerMovementSystem;
//# sourceMappingURL=module.js.map